import React, { Component, Fragment } from 'react';

import DateHelper from 'helpers/Date';
import { PropTypes as MobxPropTypes, inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { sanitize } from '@hotmart/devsec-toolkit';

@inject('UserStore')
@observer
export default class NotificationItemContent extends Component {
  static propTypes = {
    date: PropTypes.number,
    text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    UserStore: MobxPropTypes.objectOrObservableObject
  };

  render() {
    const { date, text } = this.props;
    const { shortLocale } = this.props.UserStore;
    const sanitizedHTML = sanitize({ html: text });

    const locale = DateHelper.locales[shortLocale];

    const notificationContentText =
      typeof text !== 'string' ? (
        <span className="notification__content__text">{text}</span>
      ) : (
        <span
          className="notification__content__text"
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      );

    return (
      <Fragment>
        {notificationContentText}
        {date && (
          <span className="notification__timelapse">
            {DateHelper.distanceInWordsToNow(date, { addSuffix: true, locale })}
          </span>
        )}
      </Fragment>
    );
  }
}
